import { Observer } from 'mobx-react-lite';
import React from 'react';
import { ContextColor } from '../../constants/color.enum';
import joinClassName from '../../utils/className.utils';
import { getContextColorStyle, getContrastColorHex, isHexCode, withOpacity } from '../../utils/color.utils';
import './ColorTag.scss';
var ColorTag = function (props) {
    var isSolid = props.appearance === 'solid';
    var style = isHexCode(props.color) ? {
        backgroundColor: isSolid ? props.color : withOpacity(props.color, .38),
        color: isSolid ? getContrastColorHex(props.color) : props.color,
    } : getContextColorStyle(ContextColor.Primary, props.color);
    return React.createElement(Observer, { children: function () { return (props.children ? React.createElement("strong", { className: joinClassName('ColorTag', props.className, props.nowrap && 'nowrap', props.capitalize && 'capitalize', props.uppercase && 'uppercase'), style: style, "data-appearance": props.appearance, onClick: props.onClick }, props.children) : React.createElement(React.Fragment, null)); } });
};
export default ColorTag;
